/**
 * INTÉGRATIONS › PRETIX — la logique d'affichage, sans React (testable).
 */

/**
 * La pastille du panneau — la LECTURE la pose, jamais l'enregistrement :
 * verte seulement quand le moteur a lu Pretix (statut OK) ; « première lecture
 * en attente » tant qu'aucune lecture n'a eu lieu depuis l'allumage.
 */
export function pastilleLecturePretix(c: { enabled: boolean; status: string; token_configured: boolean }):
  { ton: 'ok' | 'warning' | 'error' | 'idle'; libelle: string; vivant: boolean } {
  if (!c.enabled) return { ton: 'idle', libelle: c.token_configured ? 'Éteinte' : 'Clé à poser', vivant: false }
  if (c.status === 'OK') return { ton: 'ok', libelle: 'Active · lecture seule', vivant: true }
  if (c.status === 'DOWN') return { ton: 'error', libelle: 'Lecture en échec', vivant: false }
  if (c.status === 'DEGRADED') return { ton: 'warning', libelle: 'Lecture partielle', vivant: false }
  return { ton: 'warning', libelle: 'Première lecture en attente', vivant: false }
}

/**
 * La phrase « Comptabilité » du panneau de lecture (19/10/2026, revue) : elle
 * REPREND la ligne du catalogue, que le serveur écrit d'après les Règles de la
 * Comptabilité et l'état de la lecture. Une phrase figée ici (« ses billets
 * s'ajoutent aux entrées ») devenait fausse dès qu'on éteignait un des deux
 * réglages, et contredisait la carte du catalogue. Catalogue pas encore lu :
 * on dit où cela se règle, sans rien promettre.
 */
export function phraseComptabilitePretix(
  capacites: { label: string; detail?: string | null }[] | null,
): string {
  const c = capacites?.find((x) => x.label === 'Comptabilité')
  if (!c?.detail) return 'Ce que la Comptabilité fait de ses billets se règle dans Comptabilité › Règles.'
  return `En Comptabilité — ${c.detail}.`
}
